"use strict";

define('uikit/elements/divider',['underscore', 'marionette', '../mixins/component.mixin', '../templates', '../channel'], function (_, Mn, ComponentMixin, Templates, channel) {
  var Divider = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui divider',
    template: Templates.UIKit['divider'],
    options: {
      horizontal: false,
      vertical: false,
      section: false,
      header: false,
      hidden: false,
      clearing: false,
      inverted: false,
      fitted: false,
      icon: '',
      text: ''
    },
    forceUpdate: {
      text: true,
      icon: true
    },
    updateAttributes: function updateAttributes() {
      this.addClass('horizontal', this.getBoolOption('horizontal')).addClass('vertical', this.getBoolOption('vertical')).addClass('section', this.getBoolOption('section')).addClass('hidden', this.getBoolOption('hidden')).addClass('header', this.getBoolOption('header')).addClass('clearing', this.getBoolOption('clearing')).addClass('inverted', this.getBoolOption('inverted')).addClass('fitted', this.getBoolOption('fitted'));
    }
  });
  channel.reply('divider', _.constant(Divider));
  return Divider;
});

